import video1 from "../assets/videos/video1.mp4";
import video2 from "../assets/videos/video2.mp4";
import video3 from "../assets/videos/video3.mp4";
import video4 from "../assets/videos/video4.mp4";
import video5 from "../assets/videos/video5.mp4";
import video6 from "../assets/videos/video6.mp4";
import video7 from "../assets/videos/video7.mp4";
import video8 from "../assets/videos/video8.mp4";
import video9 from "../assets/videos/video9.mp4";
const videos = [
  {
    src: video1,
    descrption: "Video yerekana gushyira umuntu mushya muri system",
  },
  {
    src: video2,
    descrption: "Video yerekana kongera amafaranga inzu yishyura ku kwezi",
  },
  {
    src: video3,
    descrption: "Video yerekana gushyira ikirarane kuri konti",
  },
  {
    src: video4,
    descrption:
      "Video yerekana gukura inzu kuri konti imwe igashyirwa kuri konti nshya",
  },
  {
    src: video5,
    descrption: "Video yerekana uburyo umuntu yishyura umusanzu w'umutekano",
  },
  {
    src: video6,
    descrption:
      "Video yerekana uko umukusanyamusanzu yikururira inyemezabuguzi cg inyemezabwishyu",
  },
  {
    src: video7,
    descrption:
      "Video yerekana uko umukusanyamusanzu yandika umuntu mushya akoresheje web",
  },
  {
    src: video8,
    descrption:
      "Video yerekana uko umukusanyamusanzu akura inzu kumuturage umwe akayishyira kuwundi akoresheje web",
  },
  {
    src: video9,
    descrption:
      "Video yerekana uko umukusanyamusanzu uko yongera inzu kumuntu akoresheje web",
  },
];
export default videos;
